import React, { useEffect, useState, useRef } from 'react';
import { FilePond, registerPlugin, FileStatus } from 'react-filepond';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import PropTypes from 'prop-types';

import 'filepond/dist/filepond.min.css';
import './styles.css';

registerPlugin(FilePondPluginFileValidateType);
registerPlugin(FilePondPluginFileValidateSize);

const FileUploader = props => {
  const {
    name = 'file',
    allowMultiple = true,
    allowFileSizeValidation = true,
    maxFileSize = '2MB',
    maxTotalFileSize = null,
    maxFiles = 10,
    endpoint,
    acceptedFileTypes = ['image/png', 'image/jpeg'],
    labelMaxFileSize = 'The file is too big. Max file size is {filesize}',
    onUpload,
  } = props;

  const [warning, setWarning] = useState();

  const ref = useRef();

  const onProcessFile = (error, file) => {
    if (file.status === FileStatus.PROCESSING_COMPLETE) {
      ref.current.removeFile(file);
    }
  };

  const onWarning = error => {
    if (error && error.type === 'warning' && error.body === `Max files`) {
      setWarning(
        `You can only upload a maximum of 20 photos. Remaining: ${maxFiles}`
      );
    }
  };

  useEffect(() => {
    setWarning(null);
  }, [maxFiles]);

  const onUpdateFiles = () => {
    setWarning(null);
  };

  return (
    <div className="file-uploader">
      <FilePond
        ref={ref}
        name={name}
        server={{
          url: endpoint,
          process: {
            onload: response => {
              const jsonResponse = JSON.parse(response);
              if (
                typeof onUpload === 'function' &&
                jsonResponse.status &&
                jsonResponse.status === 'OK'
              ) {
                onUpload(jsonResponse.data);
              }
            },
            onerror: response => JSON.parse(response).data,
          },
        }}
        labelFileProcessingError={response => response.body.message}
        maxParallelUploads="1"
        allowRevert={false}
        allowMultiple={allowMultiple}
        allowFileSizeValidation={allowFileSizeValidation}
        acceptedFileTypes={acceptedFileTypes}
        maxFiles={maxFiles}
        maxFileSize={maxFileSize}
        maxTotalFileSize={maxTotalFileSize}
        labelMaxFileSize={labelMaxFileSize}
        onupdatefiles={onUpdateFiles}
        onprocessfile={onProcessFile}
        onwarning={onWarning}
      />
      {warning && <div className="file-uploader__error">{warning}</div>}
    </div>
  );
};

FileUploader.propTypes = {
  name: PropTypes.string,
  allowMultiple: PropTypes.bool,
  allowFileSizeValidation: PropTypes.bool,
  maxFileSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  maxTotalFileSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  maxFiles: PropTypes.number,
  endpoint: PropTypes.string.isRequired,
  acceptedFileTypes: PropTypes.array,
  labelMaxFileSize: PropTypes.string,
  onUpload: PropTypes.func,
};

export default FileUploader;
